// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compliance[data-v-525c1820] {\n  padding: 0 16px;\n}\n.compliance__approve-btn[data-v-525c1820] {\n  align-self: end;\n}\n@media (min-width: 1024px) {\n  .compliance[data-v-525c1820] {\n    padding: 0;\n  }\n}\n\n.cashier[data-v-525c1820] {\n  min-height: calc(100vh - var(--magic-top-navigation-height, 56px));\n}", ""]);
// Exports
module.exports = exports;
